export const actionTypes = {
  REQUEST_START: 'TAPS.SITUATIONS.REQUEST_START',
  REQUEST_SUCCESS: 'TAPS.SITUATIONS.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'TAPS.SITUATIONS.REQUEST_FAILURE',
  RESET: 'TAPS.SITUATIONS.RESET',
};

export function startRequest(filterQuery) {
  return {
    type: actionTypes.REQUEST_START,
    payload: filterQuery,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}

export function resetSituations() {
  return {
    type: actionTypes.RESET,
  };
}
